import { render, staticRenderFns } from "./CheckoutPaymentWrapper.vue?vue&type=template&id=5b3847ad&scoped=true&"
import script from "./CheckoutPaymentWrapper.vue?vue&type=script&lang=js&"
export * from "./CheckoutPaymentWrapper.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutPaymentWrapper.vue?vue&type=style&index=0&id=5b3847ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3847ad",
  null
  
)

export default component.exports